export default {
    events: {
        title: 'Событие',
        date: 'Дата',
        time: 'Время',
        manager: 'Заказчик',
        lineManager: 'Линейный менеджер',
        responsible: 'Ответственный за событие',
        participants: 'Участники события',
        project: 'Относится к проекту',
        person: 'Относится к человеку',
        contact: 'Контактное лицо',
        schedule: 'Запланировал событие',
        company: 'Компания',
        comment: 'Комментарий',
        documentPick: 'Документ',
        edit: 'Редактировать',
        cancel: 'Отмена',
        save: 'Сохранить',
        transfer: 'Перевести',
        resultEdit: 'Редактировать документ',
        saveShort: 'Сохранить краткий результат',
        saveEventResult:'Сохранить результат события',
        trainer: 'Тренер',
        dateFrom: 'С',
        dateTo: 'По',
        print: 'Распечатать',
        create: {
            type: 'Тип',
            title: 'Запланировать событие с человеком: %(person)s',
            titleEnter: 'Внести документ для человека: %(person)s',
            titlePick: 'Выбрать документ из БД для человека: %(person)s',
            startTime: 'Время начала',
            endTime: 'Время окончания',
            responsible: 'Ответственный за событие (вводит результат)',
            company: 'Компания',
            employee: 'Сотрудник компании',
            coexecutor: 'Соисполнитель',
            participants: 'Участники события',
        },
        types: {
            PhoneContact: 'Разговор',
            EmplInterview: 'Интервью с рекрутером',
            Client: {
                true: 'Интервью с линейным менеджером',
                false: 'Интервью у заказчика'
            }
        },
        enterResult: 'Внести результат события',
        isHappened: 'Состоялось ли событие',
        appreciate: 'Оцените человека',
        shortResult: 'Краткий результат',
        reason: 'Причина',
        percent: '% соответствия',
        formResult: 'Заполнить форму',
        resultFromDisk: 'Файл',
        freeFormResult: 'Свободная форма',
        formDocumentResult: 'Внести документ',
        formDocumentEdit: 'Отредактировать форму',
        formDocumentEditCancel: 'Отменить',
        result: 'Результат',
        document: 'Документ',
        fillResult: 'Укажите краткий результат',
        fillReason: 'Укажите причину, почему событие не состоялось',
        unselectResult: 'Нажмите кнопку результата выбранного типа',
        good: 'Положительная',
        bad: 'Отрицательная',
        neutral: 'Нейтральная',
        simultaneously_edit: "Вы не можете одновременно редактировать событие и вносить результат события",
        allday: 'Весь день',
        tookPlaceRadio: {
            Да: "Состоялось",
            Нет: "Не состоялось"
        },
        formNotSet: 'Невозможно внести выбранный документ в Web-интерфейсе',
        fill_required_fields: 'Заполните обязательные поля в Событии',
        dateDismiss: 'Дата увольнения',
        passedProbation: 'Прошел исп. срок',
        didntPass: 'Не прошел',
        startWorking: 'Вышел на работу',
        didntStart: 'Не вышел',
        endOfProbation: 'Окончание исп. срока',
        start: 'Начало',
        salary: 'Зарплата',
        gonorar: 'Гонорар',
        workToDate: 'Окончание',
        comeToWorkDate: 'Дата выхода на работу',
        positionName: 'Должность',
        organization: 'Организация',
        department: 'Отдел',
        workPlace: 'Место работы',
        feeOfAgency: 'Гонорар кадрового агенства',
        additionaly: 'Дополнительно',
        state: 'Состояние',
        stage: 'Этап',
        whoTrudo: 'Кто трудоустроил кандидата',
    }
};
